module.exports = __webpack_public_path__ + "static/nsh-8d91928af559b0adb8df4b9630beb3fb.jpg";